import {ThemeType} from '../../../theme/types';
import {BaseBorderPxProps} from '../../base/types';
import {mapFocusBorderToBaseProperties} from '../../themed/functions';
import {EditorProps} from '../types';

export const mapEditorBorderToBaseProperties = (
  theme: ThemeType,
  focus: boolean,
  {round}: EditorProps,
): BaseBorderPxProps => {
  return mapFocusBorderToBaseProperties(theme, focus ? 'on' : 'off', {
    borderRadius: round ? '9999' : '4',
  });
};
